export default "__VITE_ASSET__DDTc_HIm__"